import { ChevronsIconLeft } from "assets/icon";
import LanguageSelector from "components/LanguageSelector";
import { useTranslation } from "react-i18next";

export default function TwAppBar(props) {
  const { t } = useTranslation()
  const { isBackBtnShow = false, onBackClick = () => { }, title = "" } = props

  return (
    <div className="relative flex justify-center py-7 min-w-full">
      {isBackBtnShow === true && (<button className="inline-flex items-center justify-start absolute left-0" onClick={onBackClick}>
        <ChevronsIconLeft w="28" h="28" />
        <div className="lbl">{t("common.back")}</div>
      </button>)}
      <div className="text-xl font-bold">{title}</div>
      <div className="absolute right-1 flex items-center top-7">
        <LanguageSelector />
      </div>
    </div>
  );
}
